import React, { useState, useEffect, useRef } from "react";
import style from './Home.module.css';
import Lottie from "lottie-web";
import search from '../../Assets/search.json';
import LuxuryCard from "../../Components/LuxuryCard/LuxuryCard";
import CardDesarrollo from "../../Components/CardDesarollo/CardDesarrollo";
import ContactUs from "../../Components/ContactUs/ContactUs";
import WorkUs from '../../Components/WorkUs/WorkUs';
import AOS from "aos"; // Importar AOS
import "aos/dist/aos.css"; // Importar estilos de AOS

const Home = () => {
    const [searchParams, setSearchParams] = useState({
        departments: "",
        propertyType: ""
    });

    const container = useRef(null);

    useEffect(() => {
        Lottie.loadAnimation({
            container: container.current,
            renderer: "svg",
            loop: true,
            autoplay: false,
            animationData: search
        });

        return () => {
            Lottie.destroy();
        };
    }, []);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true }); // Inicializar AOS con duración de animación
    }, []);

    const handleSearch = () => {
        const queryString = new URLSearchParams(searchParams).toString();
        window.location.href = `/sale?${queryString}`;
    };

    const handleSelectChange = (e) => {
        setSearchParams({
            ...searchParams,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className={style.container}>
            <div className={style.intro} data-aos="fade-up">
                <h1 className={style.title}>MUCHO MÁS QUE MUDARTE</h1>
                <div className={style.buttonsContainer}>
                    <button className={style.button} onClick={() => window.location.href='/sale'}>Quiero comprar</button>
                    <button className={style.button} onClick={() => window.location.href='/rent'}>Quiero alquilar</button>
                    <button className={style.button} onClick={() => window.location.href='/sell'}>Quiero vender</button>
                    <button className={style.button} onClick={() => window.location.href='/desarrollo'}>Desarrollo</button>
                </div>
                <div className={style.searchContainer}>
                    <div className={style.division}>
                        <select
                            name="propertyType"
                            className={style.propertyTypeDropdown}
                            value={searchParams.propertyType}
                            onChange={handleSelectChange}
                        >
                            <option value="">Selecciona tu tipo de propiedad</option>
                            <option value="departamento">Departamento</option>
                            <option value="casa">Casa</option>
                            <option value="ph">PH</option>
                            <option value="local">Local</option>
                            <option value="terrenos y lotes">Terrenos y lotes</option>
                            <option value="campos y chacras">Campos y chacras</option>
                            <option value="fondo de comercio">Fondo de comercio</option>
                            <option value="cochera">Cochera</option>
                            <option value="oficina">Oficina</option>
                            <option value="galpon">Galpón</option>
                            <option value="quinta">Quinta</option>
                            <option value="otros">Otros</option>
                        </select>
                        <button className={style.searchButton} onClick={handleSearch}>
                            <div
                                ref={container}
                                onMouseEnter={() => Lottie.play()}
                                onMouseLeave={() => Lottie.pause()}
                            />
                        </button>
                    </div>
                </div>
            </div>

            {/* Otros componentes con animaciones */}
            <div className={style.componentWrapper} data-aos="fade-up">
    <CardDesarrollo />
</div>
<div className={style.componentWrapper} data-aos="fade-up">
    <LuxuryCard />
</div>
<div className={style.componentWrapper} data-aos="fade-up">
    <ContactUs />
</div>
<div className={style.componentWrapper} data-aos="fade-up">
    <WorkUs />
</div>
            <p className={style.declaracion} data-aos="fade-up">
            By Raices (bajo la sociedad Ditova SAS) NO ejerce el corretaje inmobiliario. Cada oficina es de propiedad y gestión independiente. En cumplimiento de las leyes vigentes que regulan el corretaje inmobiliario, Ley Nacional 25.028, Ley 22.802 de Lealtad Comercial, Ley 24.240 de Defensa al Consumidor, las normas del Código Civil y Comercial de la Nación y Constitucionales, los agentes/gestores de By Raices NO ejercen el corretaje inmobiliario. Todas las operaciones inmobiliarias son objeto de intermediación y conclusión por parte de los corredores públicos inmobiliarios colegiados, cuyos datos se exhiben en cada publicación de propiedad objeto de comercialización.
            </p>
        </div>
    );
};

export default Home;
